'use client';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className='min-h-screen bg-white flex flex-col justify-center items-center'>
      <div className='text-center'>
        <h1 className='text-9xl font-bold text-black'>404</h1>
        <h2 className='text-3xl font-semibold text-black mb-4'>
          {t('errorPage.404_title')}
        </h2>
        <p className='text-zinc-500 mb-8 max-w-md'>
          {t('errorPage.404_description')}
        </p>
        <div className='w-full'>
          {/* <Button
            onClick={() => (window.location.href = '/')}
            className='bg-accent-blue hover:bg-accent-blue/90 text-white px-6 py-2 rounded-md'
          >
            {t('errorPage.go_home')}
          </Button> */}
          <Button
            onClick={() => window.history.back()}
            className='border text-black px-6 py-2 rounded-md'
          >
            {t('errorPage.go_back')}
          </Button>
        </div>
      </div>
    </div>
  );
}
